function o(n) {
  var t = Object.prototype.toString.call(n);
  return t === "[object Function]" || t === "[object AsyncFunction]" || t === "[object GeneratorFunction]" || t === "[object AsyncGeneratorFunction]";
}
export {
  o as default
};
